/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';

import { Button } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';

import { hideLastDigits, parsePhoneNumber } from '../../utils/strings';

import * as styles from './Phone.css';
import { trackPhoneButtonClick } from './tracking';
import { IPageState } from '../../types/page';
import { TUser } from '../../api';
import { IFavoriteEntity } from '../../types/results';

enum EPhoneState {
  Button = 'button',
  Text = 'text',
}

export interface IPhoneProps {
  page: IPageState;
  user: TUser;
  total: number;
  phone?: string | null;
  entityId: number;
  favoriteEntities: IFavoriteEntity[];
}

export interface IPhoneState {
  type: EPhoneState;
  text: string;
  phone: string;
}

const HOVER_TEXT = 'Показать телефон';
const COUNT_HIDE_SYMBOL = 2;

export class Phone extends React.Component<IPhoneProps, IPhoneState> {
  public constructor(props: IPhoneProps) {
    super(props);

    const phone = props.phone ? parsePhoneNumber(props.phone) : '';

    this.state = {
      type: EPhoneState.Text,
      text: hideLastDigits(phone, COUNT_HIDE_SYMBOL),
      phone,
    };
  }

  public render() {
    const { type, text, phone } = this.state;

    if (!phone) {
      return null;
    }

    const phoneText = <span className={styles['phone']}>{phone}</span>;

    return (
      <>
        <div className={styles['container']}>
          {type !== EPhoneState.Text ? (
            phoneText
          ) : (
            <span>
              <Button
                size="XS"
                fullWidth={true}
                onClick={this.handleClick}
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
              >
                {text}
              </Button>
            </span>
          )}
        </div>
        <div {...mergeStyles(styles['container'], styles['print-mode'])}>{phoneText}</div>
      </>
    );
  }

  private handleMouseOver = () => this.setState({ text: HOVER_TEXT });

  private handleMouseOut = () => {
    const { phone } = this.props;

    // tslint:disable-next-line:no-non-null-assertion
    this.setState({ text: hideLastDigits(parsePhoneNumber(phone!), COUNT_HIDE_SYMBOL) });
  };

  private handleClick = () => {
    const { page, user, total, favoriteEntities, entityId } = this.props;

    this.setState({ type: EPhoneState.Button });
    trackPhoneButtonClick(page, user, entityId, favoriteEntities, total);
  };
}
